import { render, staticRenderFns } from "./EntityRecommendationsConsiderations.vue?vue&type=template&id=558952f2&scoped=true&"
import script from "./EntityRecommendationsConsiderations.vue?vue&type=script&lang=js&"
export * from "./EntityRecommendationsConsiderations.vue?vue&type=script&lang=js&"
import style0 from "./EntityRecommendationsConsiderations.vue?vue&type=style&index=0&id=558952f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558952f2",
  null
  
)

export default component.exports